(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ReportingPendingFieldDocuments', ReportingPendingFieldDocuments);

    ReportingPendingFieldDocuments.$inject = ['$resource'];

    function ReportingPendingFieldDocuments($resource) {
        return $resource('api/reporting-pending-field-documents', {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
